
import _ from 'lodash';
import {mapState, mapActions, mapMutations} from 'vuex';

export default {
	name: 'ChatApp',
    sockets: {
        connect() {
        	console.log('pageName >>', this.pageName);
            console.log('SOCKETS--  connected');
            if (this.widget){
            	this.initWidget();
            }else{
	            // 2. USE LOGIN PAGE TO GET PROFILE
	           	this.initUserData();
            }
        },
        onAddFriend(data) {
        	console.log('SOCKETS-- onAddFriend', data);
        	// 1. ADD ROOM
        	this.addRoom(data.item);
        	// 2. JOIN ROOM
        	this.$socket.emit('joinRoom', {clientCid: this.cid, roomCid: data.item.roomCid}, (res) => {
        		console.log('CB joinRoom', res);
        	});
        },
        onNewMessage(data) {
        	console.log('SOCKETS-- onNewMessage', data);
        	var currentOpen = false;
        	if (this.selectedRoom && this.selectedRoom.roomCid == data.roomCid) {
        		this.addMessage(data);
        		currentOpen = true;
        	}

        	// UPDATE UNREAD MESSAGE COUNT
        	this.updateUnreadMessageCount(data.roomCid, currentOpen);
        },
        onDeleteMessage(data) {
        	console.log('SOCKETS-- onDeleteMessage', data);
        	let currentOpen = false;
        	if (this.selectedRoom && this.selectedRoom.roomCid == data.roomCid) {
        		this.removeMessage(data);
        		currentOpen = true;
        	}

        	// UPDATE UNREAD MESSAGE COUNT
        	this.updateUnreadMessageCount(data.roomCid, currentOpen);
        },
        onUpdateRoom(data) {
        	console.log('SOCKETS-- onUpdateRoom', data);

        	if (data.fields && data.fields.length > 0) {
        		data.fields.forEach(element => {
        			this.updateRoomField(element);
        		});
        	} else if (data.field) {
        		this.updateRoomField(data.field);
        	} else {
        		console.log('error update room');
        	}
        },
        onJoinPublicRoom(data) {
        	console.log('SOCKETS-- onJoinPublicRoom', data);
        	if (!data.isok) return;
        	// 1. ADD ROOM
        	const room = data.item;
        	this.addRoom(room);
        	// 2. MULTIPLE/SINGLE BROWSER<SAME USER ID> TO JOIN ROOM
        	this.$socket.emit('joinRoom', {clientCid: this.cid, roomCid: room.roomCid}, (res) => {
        		console.log('CB joinRoom', res);
        		if (!res.isok) return;
        		this.setSelectedRoom(room);
        		// 2.2 GET 'ROOM SELECTED' <MESSAGE>
        		if (this.selectedRoom) {
					const roomCid = this.selectedRoom.roomCid;
					// this.$socket.emit('getMessages', {clientCid: this.cid, roomCid}, (data) => {
					// 	console.log('CB getMessages', data);
					// 	this.setMessageList(data.items);
					// });
					this.$socket.emit('getMoreMessages', {clientCid: this.cid, roomCid, messageCid: -1}, (data) => {
						console.log('CB getMoreMessages', data);
						this.setMessageList(data.items);
					});
        		}
        	});
        },
    },
	data () {
		return {

		};
	},
	computed: {
		...mapState({
			cid: state => state.chatapp.cid,
			name: state => state.chatapp.name,
			email: state => state.chatapp.email,

			roomList: state => state.chatapp.roomList,

			pageName: state => state.chatapp.pageName,
			selectedRoom: state => state.chatapp.selectedRoom,
			widget: state => state.chatapp.widget,
			mobile: state => state.chatapp.mobile,
		})
	},
	mounted() {
		this.setWidget(this.mywidget);
		this.initWidget();
	},
	methods: {
		...mapActions({
			saveUserData: 'chatapp/saveUserData',
			loadUserData: 'chatapp/loadUserData',
			loadSelectedRoom: 'chatapp/loadSelectedRoom',
		}),
		...mapMutations({
			setSelectedRoom: 'chatapp/setSelectedRoom',
			setRoomList: 'chatapp/setRoomList',
			updateRoom: 'chatapp/updateRoom',
			updateRoomField: 'chatapp/updateRoomField',
			addRoom: 'chatapp/addRoom',
			setMessageList: 'chatapp/setMessageList',
			addMessage: 'chatapp/addMessage',
			removeMessage: 'chatapp/removeMessage',
			setPageName: 'chatapp/setPageName',
			setWidget: 'chatapp/setWidget',
			setMobile: 'chatapp/setMobile',
		}),
		async initUserData() {
			// 1. LOAD USER PROFILE
			let email, name, clientCid;
			try {
				const userData = await this.loadUserData();
				console.log('userData', userData);
				email = userData.email;
				name = userData.name;
				clientCid = userData.cid;
			} catch(error) { 
				console.log('error', error);
				if (error.message == 'userdata not found') {
					this.setPageName('/LOGIN');
					return;
				}
			}

			// 2. LOAD SELECTED ROOM
			try {
				const roomData = await this.loadSelectedRoom();
				console.log('roomData', roomData);
			} catch(error) { 
				console.log('error', error);
			}

			// 3. START LOGIN
			this.$socket.emit('login', {email}, (data) => {
				console.log('CB login', data);
				// 3.1 LOAD ROOM LIST
				this.$socket.emit('getRoomList', {clientCid}, (data) => {
					console.log('CB getRoomList', data);
					this.setRoomList(data.items);
					// 3.2 LOAD ROOM MESSAGE
					if (this.selectedRoom) {
						const roomCid = this.selectedRoom.roomCid;
						this.$socket.emit('getMessages', {clientCid, roomCid}, (data) => {
							console.log('CB getMessages', data);
							this.setMessageList(data.items);
							this.setPageName('/MESSAGE');
						});
					} else {
						this.setPageName('/MESSAGE');
					}
				});
			});
		},
		updateUnreadMessageCount(roomCid, currentOpen) {
			const clientCid = this.cid;
			this.$socket.emit('updateRoom', {clientCid, roomCid, currentOpen}, (data) => {
				console.log('CB updateRoom', data);
				if (!data.isok) return;

				const {roomCid, unread} = data.item;
				const index = _.findIndex(this.roomList, {roomCid});
				if (index < 0) return;
				const obj = {
					...this.roomList[index]
				};
				obj.unread = unread;
				this.updateRoom(obj);
			});
		},
		initWidget() {
			console.log('this.widget >> ', this.widget);
	        if (!this.widget) return;

        	const name = this.myname.trim();
        	const email = this.myemail.trim();

        	// 1 CHECKING PROPS
        	if (name == '' || email == '') {
        		console.log('invalid props value');
        		return;	
        	}

        	// 2 SOCKET LOGIN
			this.$socket.emit('login', {email, name}, (res) => {
				console.log('CB login', res);
				this.saveUserData(res.item);
				const clientCid = res.item.cid;
				// 2. LOAD ROOM LIST
				this.$socket.emit('getRoomList', {clientCid}, (data) => {
					console.log('CB getRoomList', data);
					this.setRoomList(data.items);
				});
				this.setPageName('/MESSAGE');
			});
		},
	},
	props: ['myemail', 'myname', 'mywidget']
}
